"use strict";

var DESKTOP_BREAKPOINT = 769;

var $overlay = null;
var $lastFocusedTrigger = null;
var isCurrentlyOpen = false;
var focusPending = false;

/**
 * @returns {boolean} true si el ancho actual corresponde a desktop — se
 *   chequea en vivo, no cacheado (a diferencia de minicart.js, que cachea
 *   windowWidth una sola vez al cargar el módulo).
 */
function isDesktop() {
    return $(window).width() >= DESKTOP_BREAKPOINT;
}

/**
 * @returns {jQuery} el overlay, creándolo si no existe todavía
 */
function ensureOverlay() {
    if ($overlay && $overlay.length) {
        return $overlay;
    }

    $overlay = $('<div class="minicart-overlay" data-js-minicart-overlay></div>');

    // Se agrega DENTRO de <header>, no como hijo de <body> — si header
    // tiene su propio position + z-index (crea su propio contexto de
    // apilamiento), un elemento AFUERA de header solo se compara contra
    // el z-index del header completo (no contra los z-index internos de
    // sus hijos, como el popover). Agregándolo adentro, el overlay
    // compite en el mismo contexto que el popover — ahí sí importa el
    // z-index relativo entre los dos (1030 vs 1040).
    var $header = $("header").first();

    if ($header.length) {
        $header.append($overlay);
    } else {
        // Fallback defensivo — si por algún motivo no hay <header>, que
        // no rompa, aunque en ese caso el problema de stacking context
        // puede reaparecer si algo más en la página también crea su
        // propio contexto.
        $("body").append($overlay);
    }

    return $overlay;
}

/**
 * @param {jQuery} $panel
 * @returns {jQuery} elementos focuseables visibles dentro del panel
 */
function getFocusable($panel) {
    return $panel
        .find(
            'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])',
        )
        .filter(":visible");
}

/**
 * Intenta mover el foco al primer elemento focuseable del panel. Si
 * todavía no hay nada (contenido async sin llegar), deja focusPending en
 * true para reintentar cuando el observer de childList detecte que el
 * contenido se inyectó.
 * @param {jQuery} $panel
 * @returns {void}
 */
function trySetInitialFocus($panel) {
    var $focusable = getFocusable($panel);

    if ($focusable.length) {
        $focusable.first().trigger("focus");
        focusPending = false;
    } else {
        focusPending = true;
    }
}

/**
 * Focus trap manual — Escape dispara el mismo cierre real (removeClass
 * "show"), no uno paralelo.
 * @param {jQuery} $panel
 * @returns {void}
 */
function trapFocus($panel) {
    $panel.on("keydown.minicartTrap", function (e) {
        if (e.key === "Escape" || e.keyCode === 27) {
            $panel.removeClass("show");
            return;
        }

        if (e.key !== "Tab") {
            return;
        }

        var $focusable = getFocusable($panel);

        if (!$focusable.length) {
            return;
        }

        var $first = $focusable.first();
        var $last = $focusable.last();

        if (e.shiftKey && document.activeElement === $first[0]) {
            e.preventDefault();
            $last.trigger("focus");
        } else if (!e.shiftKey && document.activeElement === $last[0]) {
            e.preventDefault();
            $first.trigger("focus");
        }
    });
}

/**
 * @param {jQuery} $panel - .minicart .popover, ya con la clase "show"
 * @returns {void}
 */
function handleOpen($panel) {
    if (!isDesktop() || isCurrentlyOpen) {
        return;
    }

    isCurrentlyOpen = true;
    $lastFocusedTrigger = $(document.activeElement);

    var $ov = ensureOverlay();

    // eslint-disable-next-line no-unused-expressions
    $ov[0].offsetHeight; // forzar reflow para que la transición dispare

    $ov.addClass("is-visible");
    $("body").addClass("minicart-open");

    $ov.off("click.minicartOverlay").on("click.minicartOverlay", function () {
        $panel.removeClass("show");
    });

    trapFocus($panel);
    trySetInitialFocus($panel); // puede quedar pendiente si el contenido async no llegó todavía
}

/**
 * @param {jQuery} $panel
 * @returns {void}
 */
function handleClose($panel) {
    if (!isCurrentlyOpen) {
        return;
    }

    isCurrentlyOpen = false;
    focusPending = false;

    if ($overlay) {
        $overlay.removeClass("is-visible");
    }

    // No toca la posición de scroll — overflow:hidden nunca la movió.
    $("body").removeClass("minicart-open");

    $panel.off("keydown.minicartTrap");

    if ($lastFocusedTrigger && $lastFocusedTrigger.length) {
        $lastFocusedTrigger.trigger("focus");
    }

    $lastFocusedTrigger = null;
}

/**
 * Observa .minicart .popover en 2 dimensiones a la vez:
 *  - "class" → decide abrir/cerrar el overlay, sin importar quién agregue
 *    o saque "show" (hover del header, add-to-cart, botón cerrar, click
 *    afuera, Escape — todos pasan por el mismo removeClass/addClass).
 *  - "childList" → detecta cuándo el contenido async (el $.get de
 *    minicart.js) efectivamente se inyecta, para recién ahí mover el foco
 *    inicial si había quedado pendiente (ver trySetInitialFocus).
 * @returns {void}
 */
function init() {
    // Gate por flag — evita registrar el MutationObserver y crear el
    // overlay en sitios/momentos donde el feature está apagado. Mismo
    // patrón que ya usa deliverySelector.js (PDP) para leer el flag del
    // lado del cliente — OJO: depende de que ese hidden input exista en
    // TODAS las superficies donde vive el MiniCart (PDP/PLP/Home/Cart),
    // no solo en PDP. Si el input es específico de PDP, hay que moverlo a
    // un include global (ej. dentro del header) para que esto no rompa
    // el overlay en el resto de las páginas.
    var enableStoreSelector = $('[name="enableStoreSelector"]').val() === "true";

    if (!enableStoreSelector) {
        return;
    }

    var $panel = $(".minicart .popover"); 

    if (!$panel.length) {
        return;
    }

    var wasVisible = $panel.hasClass("show");

    var observer = new MutationObserver(function (mutations) {
        var classChanged = false;
        var childListChanged = false;

        mutations.forEach(function (mutation) {
            if (mutation.type === "attributes" && mutation.attributeName === "class") {
                classChanged = true;
            } else if (mutation.type === "childList") {
                childListChanged = true;
            }
        });

        if (classChanged) {
            var isVisible = $panel.hasClass("show");

            if (isVisible && !wasVisible) {
                handleOpen($panel);
            } else if (!isVisible && wasVisible) {
                handleClose($panel);
            }

            wasVisible = isVisible;
        }

        if (childListChanged && isCurrentlyOpen && focusPending) {
            trySetInitialFocus($panel);
        }
    });

    observer.observe($panel[0], {
        attributes: true,
        attributeFilter: ["class"],
        childList: true,
    });

    $("body").on("click", "[data-js-minicart-primary-cta]", function () {
        var $cta = $(this);
        var canonicalEvents = require("../analytics/canonicalEvents");
    
        var deliveryMethod = $cta.data("delivery-method") || null;
        var storeId = $cta.data("store-id") || null;
    
        var selectedStore = storeId
            ? canonicalEvents.toStorePayload({
                ID: storeId,
                name: $cta.data("store-name") || null,
                city: $cta.data("store-city") || null,
            })
            : null;
    
        canonicalEvents.pushCanonicalEvent("minicart_primary_cta_click", {
            surface: "minicart",
            source: "post_add_to_cart_minicart",
            selected_store: selectedStore,
            delivery_method: deliveryMethod || null,
            cta_text: $cta.text().trim(),
            cta_target: $cta.data("cta-target") || null,
        });
    })
}

module.exports = {
    init: init,
};